import moment from "moment";
moment.locale("es-mx");
const FormatDateFinal = ({ FechaBaja }: any) => {
  const dateFormat = moment.utc(FechaBaja).format("L");
  return <span>{FechaBaja ? dateFormat : ""}</span>;
};

export default FormatDateFinal;
